import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'float-patient-waiting-list',
  templateUrl: './float-patient-waiting-list.component.html',
  styleUrl: './float-patient-waiting-list.component.scss'
})
export class FloatPatientWaitingListComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    this.minimize();
  }
  ngOnInit(): void {

  }


  minimized: boolean = true;
  @ViewChild('waitBox') waitBox !: ElementRef
  minimize() {
    this.minimized = true
    this.waitBox.nativeElement.style.margin = "0 0 -466px 0";
  }
  maxi() {
    this.minimized = false;
    this.waitBox.nativeElement.style.margin = "0";
  }
  toggle() {
    this.minimized ? this.maxi() : this.minimize();
  }
  refresh() { }
}
